import { API_BASE_URL, TIMEOUTS, fetchWithSession, requestJson } from './http';

const repoUrl = (trackerId, suffix) => `${API_BASE_URL}/api/v1/repo-sync/${trackerId}${suffix}`;

export const saveJournal = (trackerId, markdown) =>
  requestJson(repoUrl(trackerId, '/journal'), {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ markdown }),
    fallbackMessage: 'Failed to save journal',
  });

export const fetchJournal = (trackerId) =>
  requestJson(repoUrl(trackerId, '/journal'), { fallbackMessage: 'Failed to load journal' });

export const uploadArtifact = async (trackerId, { file, path }) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('path', path);
  const response = await fetchWithSession(
    repoUrl(trackerId, '/artifact'),
    { method: 'POST', body: formData },
    TIMEOUTS.upload
  );
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    if (response.status === 404) {
      throw new Error('Artifact upload endpoint is not available on this backend yet. Deploy the updated API, then try again.');
    }
    throw new Error(payload.detail || 'Artifact upload failed');
  }
  return response.json();
};

// Commits the journal to the cohort repo. Given a GitHub round trip on the
// server this is the slowest call in the save chain, so it gets the long
// deadline — and callers must treat its failure as recoverable, because the
// journal itself is already saved server-side by this point.
export const pushJournalToGitHub = (trackerId) =>
  requestJson(repoUrl(trackerId, '/github-push'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    timeout: TIMEOUTS.github,
    fallbackMessage: 'GitHub push failed',
  }); // { commit_sha, commit_url, repo_url }

export const runJournalCoach = (trackerId, { markdown = '', trackTitle = '' } = {}) =>
  requestJson(repoUrl(trackerId, '/journal-coach'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ markdown, track_title: trackTitle }),
    timeout: TIMEOUTS.llm,
    fallbackMessage: 'Journal coach failed',
  });
